import { Sms as Sms_kojaro } from './Sms.kojaro';
import { Sms as Sms_phosphor } from './Sms.phosphor';
import { Sms as Sms_zoomg } from './Sms.zoomg';
import { Sms as Sms_zoomit } from './Sms.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Sms_kojaro;

    case 'zoomg':
      return Sms_zoomg;

    case 'phosphor':
      return Sms_phosphor;

    default:
      return Sms_zoomit;
  }
};

export const Sms = IconRenderer();
